import { render, staticRenderFns } from "./HelpTab.vue?vue&type=template&id=b62dd8c8&scoped=true&"
import script from "./HelpTab.vue?vue&type=script&lang=js&"
export * from "./HelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62dd8c8",
  null
  
)

export default component.exports